import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn/ui convention: merge conditional classnames then dedupe Tailwind classes. */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
